import type { ReactNode } from 'react'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export type DashboardChartCardProps = {
  title: string
  description?: string
  children: ReactNode
  loading?: boolean
  error?: ReactNode
  className?: string
  contentClassName?: string
}

export function DashboardChartCard({
  title,
  description,
  children,
  loading = false,
  error,
  className,
  contentClassName,
}: DashboardChartCardProps) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className={description ? undefined : 'text-lg'}>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent className={cn(contentClassName)}>
        {error ? (
          <p className="text-sm text-destructive">{error}</p>
        ) : loading ? (
          <Skeleton className="min-h-[200px] w-full rounded-lg" aria-busy="true" />
        ) : (
          children
        )}
      </CardContent>
    </Card>
  )
}
